import {
  Box,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

interface FBOActivityProps {
  fbos: any[] | undefined;
}

export const FBOActivity: React.FC<FBOActivityProps> = ({ fbos }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={3} sx={{ width: "100%", p: 1 }}>
      <Typography variant="h6">{t("screens.fboActivity.title")}</Typography>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          p: 3,
          backgroundColor: "background.paper",
        }}
      >
        <Typography
          variant="h6"
          color="text.secondary"
          gutterBottom
          align="center"
        >
          {t("screens.fboActivity.comingSoonTitle")}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
          {t("screens.fboActivity.comingSoonDescription")}
        </Typography>

        {/* Simple FBO List */}
        {fbos && fbos.length > 0 && (
          <Box sx={{ maxHeight: 400, overflow: "auto" }}>
            <Typography variant="subtitle2" gutterBottom>
              {t("screens.fboActivity.fboAccountsTitle", { count: fbos.length })}
            </Typography>
            <Grid container spacing={1}>
              {fbos.map((fbo) => (
                <Grid item xs={12} sm={6} md={4} key={fbo.id}>
                  <Box
                    sx={{
                      p: 1.5,
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      backgroundColor: "background.default",
                    }}
                  >
                    <Typography variant="body2">{fbo.name}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {t("screens.fboActivity.activityDataComingSoon")}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Box>
    </Stack>
  );
};